"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var RichTextEditorResultsRecord = (0, _immutable.Record)({
  editorState: null,
  contentChanged: false,
  contentMediator: null
}, 'RichTextEditorResultsRecord');

var RichTextEditorResults =
/*#__PURE__*/
function (_RichTextEditorResult) {
  (0, _inherits2.default)(RichTextEditorResults, _RichTextEditorResult);

  function RichTextEditorResults() {
    (0, _classCallCheck2.default)(this, RichTextEditorResults);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(RichTextEditorResults).apply(this, arguments));
  }

  (0, _createClass2.default)(RichTextEditorResults, [{
    key: "hasState",
    value: function hasState() {
      return !!this.editorState;
    }
  }, {
    key: "hasContent",
    value: function hasContent() {
      return this.hasState() && this.contentMediator.hasContent(this.editorState);
    }
  }, {
    key: "toRawEditorContent",
    value: function toRawEditorContent() {
      return (0, _immutable.fromJS)(this.contentMediator.toJson(this.editorState.getCurrentContent()));
    }
  }, {
    key: "pushRawEditorContent",
    value: function pushRawEditorContent(rawEditorContent) {
      if (_immutable.Map.isMap(rawEditorContent)) {
        rawEditorContent = rawEditorContent.toJS();
      }

      var contentState = this.contentMediator.fromJson(rawEditorContent);
      var editorState = this.contentMediator.setContent(this.editorState, contentState);
      return this.setEditorState(editorState);
    }
  }, {
    key: "pushContent",
    value: function pushContent(html) {
      var undoable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var contentState = this.contentMediator.fromHtml(html);
      var editorState = this.contentMediator.setContent(this.editorState, contentState, undoable);
      return this.setEditorState(editorState);
    }
  }, {
    key: "resetEditorState",
    value: function resetEditorState() {
      var editorState = this.contentMediator.resetContent();
      return this.setEditorState(editorState);
    }
  }, {
    key: "setEditorState",
    value: function setEditorState(editorState) {
      var contentChanged = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return this.merge({
        editorState: editorState,
        contentChanged: contentChanged
      });
    } // Caution, this operation is expensive, do not call on every change!

  }, {
    key: "html",
    value: function html() {
      if (!this._html) {
        this._html = this.contentMediator.toHtml(this.editorState.getCurrentContent());
      }

      return this._html;
    }
  }, {
    key: "plainText",
    value: function plainText() {
      if (!this._plainText) {
        this._plainText = this.editorState.getCurrentContent().getPlainText();
      }

      return this._plainText;
    }
  }, {
    key: "atMentions",
    value: function atMentions() {
      if (!this._atMentions) {
        this._atMentions = this.contentMediator.getAtMentions(this.editorState.getCurrentContent());
      }

      return this._atMentions;
    }
  }, {
    key: "numberOf",
    value: function numberOf(property, getter) {
      if (!this[property]) {
        this[property] = getter(this.editorState.getCurrentContent());
      }

      return this[property];
    }
  }, {
    key: "numberOfImages",
    value: function numberOfImages() {
      return this.numberOf('_numberOfImages', this.contentMediator.getNumberOfImages);
    }
  }, {
    key: "numberOfVideos",
    value: function numberOfVideos() {
      return this.numberOf('_numberOfVideos', this.contentMediator.getNumberOfVideos);
    }
  }, {
    key: "numberOfLinks",
    value: function numberOfLinks() {
      return this.numberOf('_numberOfLinks', this.contentMediator.getNumberOfLinks);
    }
  }, {
    key: "transform",
    value: function transform(transforms, opts) {
      delete this._html;
      delete this._plainText;
      delete this._atMentions;
      return this.setEditorState(transforms(this.editorState, opts), this.contentChanged);
    }
  }]);
  return RichTextEditorResults;
}(RichTextEditorResultsRecord);

exports.default = RichTextEditorResults;
module.exports = exports.default;